import { render, staticRenderFns } from "./Faq.html?vue&type=template&id=2bd502ea&external"
import script from "./Faq.js?vue&type=script&lang=js&external"
export * from "./Faq.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports